import React, { Component } from "react";
import DupontIconButton from "../DupontIconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {faEdit} from "@fortawesome/free-solid-svg-icons/faEdit"

class EditRenderer extends Component {
  constructor(props) {
    super(props);
    this.invokeParentMethod = this.invokeParentMethod.bind(this);
  }

  invokeParentMethod() {
    this.props.context.editHandler(this.props.node.data);
  }

  render() {
    return (
    
      <DupontIconButton
        onClick={this.invokeParentMethod}
      >
     <FontAwesomeIcon icon={faEdit} color="white"/>
      </DupontIconButton>
    );
  }
}

export default EditRenderer;
